import { useCallback, useEffect, useState } from 'react';

/**
 * A hook to set HTML fontSize, and provide functions to change HTML fontSize, the fontSize will be the relative to while using rem
 * @returns
 */
export const useHTMLFontSize = () => {
  const [currentFontSize, setCurrentFontSize] = useState(16);
  const [manipulate, setManipulate] = useState(0);
  const rootElement = document.documentElement;

  useEffect(() => {
    rootElement.style.fontSize = `${currentFontSize}px`;
  }, [currentFontSize, rootElement.style]);

  const increaseFont = useCallback(() => {
    setCurrentFontSize(currentFontSize + 1);
    setManipulate(manipulate + 1);
  }, [currentFontSize, manipulate]);

  const decreaseFont = useCallback(() => {
    setCurrentFontSize(currentFontSize - 1);
    setManipulate(manipulate - 1);
  }, [currentFontSize, manipulate]);

  return {
    manipulate,
    increaseFont,
    decreaseFont,
    isDisableIncrease: manipulate === 2,
    isDisableDecrease: manipulate === -2,
  };
};
